import { Box, Typography } from "@mui/material";
import React from "react";
import ScreenSearchDesktopIcon from "@mui/icons-material/ScreenSearchDesktop";

const SearchNotFound = () => {
  return (
    <Box
      sx={{
        height: "100%",
        width: "100%",
        display: "flex",
        justifyContent: "center",
        alignItems: "center",
        flexDirection: "column",
        gap: "10px",
      }}
    >
      <ScreenSearchDesktopIcon sx={{ color: "#9AAFC4", fontSize: "45px" }} />
      <Typography
        sx={{ color: "#9AAFC4", fontSize: "1.3rem", fontWeight: "bold" }}
      >
        موردی یافت نشده است
      </Typography>
    </Box>
  );
};

export default SearchNotFound;
